module.exports = __webpack_public_path__ + "big-logo-singin.png?9b2643ec442e3954514e7a44fc78f1d3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big-logo-singin.png
// module id = 4
// module chunks = 0